import { useContext } from 'react';
import { ConfigContext } from '../components/config';
import { Config } from '../models/config';

export function useConfig(): Config {
  const context = useContext(ConfigContext);

  return context;
}
